import { Image } from '@bw/elements';
import { Block } from '../../factories/types';
import { annotate } from '../../utils/annotate';
import { RichText } from '../../utils/rich-text/RichText';
import styles from './ProductGridItem.module.scss';

export const ProductGridItem: Block<'item'> = ({ data }) => {
	const {
		fields: { image, title },
	} = data;

	return (
		<div className={styles.productGridItem} {...annotate(data)}>
			{image ? (
				<Image
					src={'https:' + image.fields.file?.url}
					alt={image.fields.file?.fileName || ''}
					width={100}
					height={100}
					loading="eager"
				/>
			) : null}

			{title ? (
				<span className={styles.title}>
					<RichText document={title} />
				</span>
			) : null}
		</div>
	);
};
